export default __webpack_public_path__ + "static/media/elite crown 3.98c0ead5.svg";